import React from "react"
import { T, TraksConsumer } from "../../traks"

const Status = ({whistleStatus, ...props}) => {
	if (whistleStatus === "new")
		return <T>New</T>
	else if(whistleStatus === "processed")
		return <T>Processed</T>
	else if(whistleStatus === "passedOn")
		return <T>Passed on</T>
	else if(whistleStatus === "closed")
		return <T>Closed</T>
	
	return whistleStatus

}

export const WhistleStatus = (whistleStatus) => {
	return(
		<TraksConsumer>
			<Status whistleStatus={whistleStatus} />
		</TraksConsumer>
	)
}

